// extracted by mini-css-extract-plugin
module.exports = {"qr":"Store_qr__3NOJs"};